import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {Dropdown, Input, Menu} from 'antd';
import {StyledUserSelectDropdown} from './StyledUserSelectDropdown';
import UserDetails from '../UserDetails';
import {userRolesConstants} from '../../constants';

const UserSelectDropdown = ({
  children,
  listPropName = 'employee_id',
  onSelect,
  selectedValue,
  hideSelected = false,
  onlyAdmins = false,
  ...rest
}) => {
  const [t] = useTranslation('main');
  const [search, setSearch] = React.useState('');

  const employees = useSelector(state => state.company.employees || []);

  const filteredEmployees = React.useMemo(() => {
    if (!Array.isArray(employees) || employees.length === 0) return [];
    const normalizedSearch = search.trim().toLowerCase();
    return employees.filter(emp => {
      const name = (emp.full_name || '').toLowerCase();
      if (normalizedSearch && !name.includes(normalizedSearch)) return false;
      if (hideSelected && emp[listPropName] === selectedValue) return false;
      if (onlyAdmins && emp.role !== userRolesConstants.ADMIN) return false;
      return true;
    });
  }, [employees, hideSelected, listPropName, selectedValue, onlyAdmins, search]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Dropdown
      trigger={['click']}
      popupRender={() => (
        <StyledUserSelectDropdown>
          <Input
            onChange={e => setSearch(e.target.value)}
            placeholder={t('search')}
            value={search}
          />
          <Menu onClick={({ domEvent, key }) => onSelect?.(domEvent, key)}>
            {filteredEmployees.map((emp) => (
              <Menu.Item key={emp[listPropName]}>
                <UserDetails user={emp} email={false} avatarProps={{ size: 24 }} />
              </Menu.Item>
            ))}
          </Menu>
        </StyledUserSelectDropdown>
      )}
      {...rest}
    >
      {children}
    </Dropdown>
  );
}

UserSelectDropdown.propTypes = {
  listPropName: PropTypes.string,
  onSelect: PropTypes.func,
  selectedValue: PropTypes.any,
  hideSelected: PropTypes.bool,
  onlyAdmins: PropTypes.bool,
}

export default UserSelectDropdown;
